import React, { useState, useRef, useEffect } from "react";
import { IconButton, Typography } from "@mui/material";
import { ChevronLeft, ChevronRight } from "@mui/icons-material";
import Grid from "@mui/material/Grid2";
import { Link } from "react-router-dom";
import Footer from "../../Footer/Footer";
import Header from "../../Header/MegaMenu";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import "owl.carousel"; // Import Owl Carousel AFTER jQuery
import OwlCarousel from "react-owl-carousel";
// import '../outterpages.css'
// import curreciesBan from '../../../assets/Images/Outterpage/currencies-banner-img.png';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { styled } from "@mui/material/styles";
import Avatar from '@mui/material/Avatar';
import AvatarGroup from '@mui/material/AvatarGroup';
import Stack from '@mui/material/Stack';
import eng from '../../../assets/Images/Outterpage/eng.webp'
import jap from '../../../assets/Images/Outterpage/jap.webp'
import cardimg from '../../../assets/Images/Outterpage/card-1.webp'
import sec4 from '../../../assets/Images/Outterpage/sec-4-img.webp'
import Accordion from '@mui/material/Accordion';
import AccordionActions from '@mui/material/AccordionActions';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import cpbanner from '../../../assets/Images/Outterpage/cpy-trading-banner.webp'
import sec2cp from '../../../assets/Images/Outterpage/cp-trade-sec-2.webp'
import star from '../../../assets/Images/Outterpage/cp-star.webp'
import imgcrn from '../../../assets/Images/Outterpage/img-crn.webp'
import { useScroll, useTransform, motion, useInView } from 'framer-motion'
import aboutbanner from '../../../assets/Images/Outterpage/about-banner.webp'
import introbrokerbanner from '../../../assets/Images/Outterpage/intro-broker-bg.webp'

const StyledTableRow = styled(TableRow)(({ theme }) => ({
    borderBottom: "1px solid  rgba(255, 146, 71, 1)  ",
    '&:nth-of-type(odd)': {
        background: "linear-gradient(90deg,rgba(99, 97, 97, 0.44) 15.1%,rgba(70, 69, 68, 0.49) 85.42%)",
    },
    // Hide the last border of the table
    '&:last-child td, &:last-child th': {
        border: 0,
    },
}));

// const videos = [
//   { id: 1, src: video1 },
//   { id: 2, src: video2 },
//   { id: 3, src: video3 },
//   { id: 3, src: video4 },
// ];
const testimonials = [
    {
        name: "Sherly",
        position: "CEO",
        text: "Figma ipsum component variant main layer. Library figjam subtract font rotate move auto. Figjam strikethrough bullet text device pen scale. Group horizontal link library flows ellipse flatten library undo.",
    },
    {
        name: "Carlos",
        position: "Product Manager",
        text: "An amazing experience! The support and innovation mindset Rishi brings to the team makes every project more exciting and successful.",
    },
    // {
    //   name: "Rishi",
    //   position: "CEO",
    //   text: "Regulus has truly streamlined my trading activity. The platform is incredibly user-friendly, making it easy to navigate and execute trades quickly. I've seen a noticeable improvement in my efficiency!",
    // },
];

const options = {
    margin: 50,
    items: 1,
    autoplay: true,
    autoplayTimeout: 6000,
    dots: false, // Hide default dots
    loop: true,
    smartSpeed: 800,
    nav: true, // We will use custom navigation
    responsive: {
        0: {
            dots: true,
            nav: false,
        },
        768: {
            dots: false,
            nav: true,
        },
    },
};

const marketData = [
    { id: 1, pair: "GBP/USD", value: "1,355.78", trend: "up" },
    { id: 2, pair: "GBP/USD", value: "1,120.65", trend: "down" },
    { id: 3, pair: "GBP/USD", value: "1,120.65", trend: "down" },
    { id: 4, pair: "GBP/USD", value: "1,355.78", trend: "up" },
    { id: 5, pair: "GBP/USD", value: "1,120.65", trend: "down" },
];


const tableData = [
    {
        name: "USDJPY",
        speed: "83.4",
        comission: "$0",
        margin: "0.34%,",
        longswap: "-44",
        shortswap: "-44",
        stoplevel: "0",

    },
    {
        name: "USDJPY",
        speed: "83.4",
        comission: "$0",
        margin: "0.34%,",
        longswap: "-44",
        shortswap: "-44",
        stoplevel: "0",

    },
    {
        name: "USDJPY",
        speed: "83.4",
        comission: "$0",
        margin: "0.34%,",
        longswap: "-44",
        shortswap: "-44",
        stoplevel: "0",

    },
    {
        name: "USDJPY",
        speed: "83.4",
        comission: "$0",
        margin: "0.34%,",
        longswap: "-44",
        shortswap: "-44",
        stoplevel: "0",

    },
    {
        name: "USDJPY",
        speed: "83.4",
        comission: "$0",
        margin: "0.34%,",
        longswap: "-44",
        shortswap: "-44",
        stoplevel: "0",

    },
    {
        name: "USDJPY",
        speed: "83.4",
        comission: "$0",
        margin: "0.34%,",
        longswap: "-44",
        shortswap: "-44",
        stoplevel: "0",

    },
    {
        name: "USDJPY",
        speed: "83.4",
        comission: "$0",
        margin: "0.34%,",
        longswap: "-44",
        shortswap: "-44",
        stoplevel: "0",

    },
    {
        name: "USDJPY",
        speed: "83.4",
        comission: "$0",
        margin: "0.34%,",
        longswap: "-44",
        shortswap: "-44",
        stoplevel: "0",

    },
    {
        name: "USDJPY",
        speed: "83.4",
        comission: "$0",
        margin: "0.34%,",
        longswap: "-44",
        shortswap: "-44",
        stoplevel: "0",

    },

]
const accordianData = [
    {
        question: "How Does Copy Trading Work?",
        answer: "Copy trading enables users to automatically replicate trades made by experienced traders. When a selected trader executes a trade, it is mirrored in the follower's account, reflecting the same actions in real-time.",
        panel: "panel1"
    },
    {
        question: "Is Copy Trading Suitable for Beginners?",
        answer: "Yes, copy trading can be advantageous for beginners by enabling them to learn from expert strategies and potentially earn while gaining market insights. However, it's important to understand the associated risks.",
        panel: "panel2"
    },



]
const cardset = [
    {

        head: "Competitive commissions",
        para: "We offer competitive commissions to our IB Partners based on the trading volume of their referred clients."
    },
    {

        head: "Marketing support",
        para: "We provide marketing materials such as banners, landing pages, and promotional emails to help you attract clients to our platform."
    },
    {

        head: "Transparency",
        para: "We value transparency in all aspects of our business, including our IB Partner Program. You can access real-time reports on your referred clients's trading activity and commission earnings."
    },



]
const IntroductionBroker = () => {
    const theme = useTheme();
    const matches = useMediaQuery(theme.breakpoints.up("md"));
    const lg = useMediaQuery(theme.breakpoints.up("lg"));
    const md900 = useMediaQuery(theme.breakpoints.up("900"));
    const lg1400 = useMediaQuery(theme.breakpoints.up("1400"));
    const xl = useMediaQuery(theme.breakpoints.up("xl"));
    const [expanded, setExpanded] = React.useState('panel1');
    const lg1200 = useMediaQuery(theme.breakpoints.up("1200"));
    const md1200 = useMediaQuery(theme.breakpoints.down("1200"));
    const xs375 = useMediaQuery(theme.breakpoints.up("380.99"));

    const handleChange = (panel) => (event, newExpanded) => {
        setExpanded(newExpanded ? panel : false);
    };


    const keyMap = { a: 'cd1', b: 'cd2', c: 'cd3', d: 'cd4' };

    // Create separate refs
    const refA = useRef(null);
    const refB = useRef(null);
    const refC = useRef(null);
    const refD = useRef(null);

    // Use useInView for each
    const isInViewA = useInView(refA, { once: true });
    const isInViewB = useInView(refB, { once: true });
    const isInViewC = useInView(refC, { once: true });
    const isInViewD = useInView(refD, { once: true });
    // margin: '-70% 0px -70% 0px',
    // const [cardshow, setCardshow] = React.useState({
    //     cd1: false,
    //     cd2: false,
    //     cd3: false,
    //     cd4: false,
    //   });

    // const keyMap = { a: 'cd1', b: 'cd2', c: 'cd3', d: 'cd4' };


    // const ref = useRef({});
    // const setRef = (key) => (el) => {
    //     if (el) {
    //       ref.current[key] = el;

    //       setCardshow((prev) => ({
    //         ...prev,
    //         [keyMap[key]]: true, // ← This now works because key is in scope
    //       }));
    //     }
    //   };

    // setCardshow((prev) => ({
    //     ...prev,
    //     [keyMap[key]]: true,
    // }));
    // const setRef = (key) => (el) => {
    //     if ('a') {
    //         ref.current[key] = setcardshow((prev => ({ ...prev, cd1: true })));
    //     }
    //     else if ('b') {
    //         ref.current[key] = setcardshow((prev => ({ ...prev, cd2: true })));
    //     }
    //     else if ('c') {
    //         ref.current[key] = setcardshow((prev => ({ ...prev, cd3: true })));
    //     }
    //     else if ('d') {
    //         ref.current[key] = setcardshow((prev => ({ ...prev, cd4: true })));
    //     }
    // };
    // const isInView = useInView(ref, { once: false });
    // const isInView = useInView(ref, {
    //   margin: '-50% 0px -50% 0px', 
    //   once: true, 
    // });

    return (
        <div className="OutterPage">
            <Header />
            <div className="bg-outer">
                <section className="banner outter-banner">
                    <div className="contain-width">
                        <Grid container sx={{ alignItems: "flexStart" }}>
                            <Grid item size={{ xs: 12, sm: 12, md: 6, lg: 6, xl: 6 }} sx={{ placeContent: "center" }}>
                                <div
                                    className="banner-left "
                                    style={{ height: xl ? "500px" : "auto", placeContent: "center" }}
                                >
                                    <p>Partner</p>
                                    <h1 className="mb-30 mt-10">
                                        Introducing <span> Broker</span>
                                    </h1>
                                    <p>Welcome to our IB Partner Program! As a forex broker, we understand the importance of partnerships and collaborations in the ever-evolving financial industry. That's why we offer an IB (Introducing Broker) Partner Program to help you grow your business while offering your clients access to the best forex trading experience.</p>
                                    <div
                                        className="display-1 btn flex-wrap mt-20"
                                        style={{ marginBottom: matches ? "40px" : "20px" }}
                                    >
                                        <Link to="#" className="bg-btn">
                                            Join Now
                                        </Link>
                                    </div>
                                </div>
                            </Grid>
                            <Grid item size={{ xs: 12, sm: 12, md: 6, lg: 6, xl: 6 }}>

                                <div className="text-center ">
                                    <img width="90%" src={introbrokerbanner} />
                                </div>
                            </Grid>
                        </Grid>
                    </div>
                </section>
                <section className="trade-easy sec-3">
                    <div className="contain-width">
                        <div className="heading">
                            {/* <p>Our Services</p> */}
                            <h2>
                                Why Become an <span>IB Partner</span> with us?
                            </h2>
                            <p>At our forex brokerage, we are committed to providing the best possible experience for our clients.</p>

                        </div>

                        <Grid container spacing={5} className="mt-50">

                            {
                                cardset.map((item) => (
                                    <Grid item size={{ xs: 12, sm: 12, md: 6, lg: 4, xl: 4 }} className="why-choose-card mt-10" sx={{ alignItems: !md900 && "center" }}>
                                        <div>
                                            <img src={cardimg} />
                                        </div>
                                        <p className="mt-10 head"><span className="grd">{item.head}</span></p>
                                        <p className="mt-10">{item.para}</p>

                                    </Grid>
                                ))
                            }

                        </Grid>


                    </div>
                </section>

                <section className="trade-easy sec-3 roadmap-bg2  ">
                    <div className="contain-width">
                        <div className="heading">
                            {/* <p>
                                <span>INSTALL</span>
                            </p> */}
                            <h2>
                          Steps to avail tradable bonus
                            </h2>

                        </div> 
                        <Grid container spacing={5} className="card-set-mt card-set-introbr ">
                            <Grid size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }} className="mt-box ">
                                <span className="crn-alg">
                                    {
                                        xs375 && <span className="crn-box">
                                            <img width="90%" src={imgcrn} />
                                        </span>
                                    }
                                    <div className="txt-content" style={{ padding: "30px 100px", textAlign: "center" }}>
                                        <p>Step 2</p>
                                        <p><span className="grd">Apply for our IB Partner Program.</span></p>
                                    </div>
                                </span>
                            </Grid>
                            <Grid size={{ xs: 12, sm: 12, md: 12, lg: 6, xl: 6 }} className={md1200 ? "mt-box" : "mt-box mt-50 "}>
                                <span className="crn-alg">
                                    {
                                        xs375 && <span className="crn-box">
                                            <img width="90%" src={imgcrn} />
                                        </span>
                                    }
                                    <div className="txt-content" style={{ padding: "30px 100px", textAlign: "center" }}>
                                        <p>Step 1</p>
                                        <p><span className="grd">Sign up for an account on our website.</span></p>
                                    </div>
                                </span>
                            </Grid>
                            <Grid size={{ xs: 12, sm: 12, md: 12, lg: 6, xl: 6 }} className={md1200 ? "mt-box" : "mt-box mt-50 "}>
                                <span className="crn-alg">
                                    {
                                        xs375 && <span className="crn-box">
                                            <img width="90%" src={imgcrn} />
                                        </span>
                                    }
                                    <div className="txt-content" style={{ padding: "30px 100px", textAlign: "center" }}>
                                        <p>Step 3</p>
                                        <p><span className="grd">Once your application is approved, start referring clients to us and earn commissions based on their trading volume.</span></p>
                                    </div>
                                </span>
                            </Grid>
                        </Grid>


                    </div>
                </section>
                <section className="trade-easy sec-3 mb-30 intro-bro-crd">
                    <div className="contain-width">
                        <div className="heading">
                            {/* <p>
                                <span>Why Finowiz</span>
                            </p> */}
                            <h2>
                             What we <span>offer?</span>
                            </h2>
                            <p>
                             Becoming an IB (Introducing Broker) with our forex brokerage comes with numerous benefits. Here are some of the key advantages of partnering with us:
                            </p>
                        </div>
                        <Grid container spacing={5} >
                            <Grid item size={{ xs: 12, sm: 12, md: 6, lg: 4, xl: 4 }} className="why-choose-card mt-10 instr-card " sx={{ alignItems: !md900 && "center" }}>
                                <div className="mt-10">
                                    <img src={cardimg} />
                                </div>
                                <p className="mt-10 head"><span className="grd">Lucrative Commissions</span></p>
                                <p className="mt-10">As an IB, you can earn commissions based on the trading volume generated by your referred clients. We offer competitive commission rates that can help you earn a substantial income.</p>

                            </Grid>
                            <Grid item size={{ xs: 12, sm: 12, md: 6, lg: 4, xl: 4 }} className="why-choose-card mt-10 instr-card " sx={{ alignItems: !md900 && "center" }}>
                                <div className="mt-10">
                                    <img src={cardimg} />
                                </div>
                                <p className="mt-10 head"><span className="grd">Customisable Rebate Plans</span></p>
                                <p className="mt-10">We provide marketing materials such as banners, landing pages, and promotional emails to help you attract clients to our platform.</p>

                            </Grid>
                            <Grid item size={{ xs: 12, sm: 12, md: 6, lg: 4, xl: 4 }} className="why-choose-card mt-10 instr-card " sx={{ alignItems: !md900 && "center" }}>
                                <div className="mt-10">
                                    <img src={cardimg} />
                                </div>
                                <p className="mt-10 head"><span className="grd">Marketing Support</span></p>
                                <p className="mt-10">We value transparency in all aspects of our business, including our IB Partner Program. You can access real-time reports on your referred clients's trading activity and commission earnings.</p>

                            </Grid>
                            <Grid item size={{ xs: 12, sm: 12, md: 6, lg: 4, xl: 4 }} className="why-choose-card mt-10 instr-card " sx={{ alignItems: !md900 && "center" }}>
                                <div className="mt-10">
                                    <img src={cardimg} />
                                </div>
                                <p className="mt-10 head"><span className="grd">Competitive commissions</span></p>
                                <p className="mt-10">We offer competitive commissions to our IB Partners based on the trading volume of their referred clients.</p>

                            </Grid>
                            <Grid item size={{ xs: 12, sm: 12, md: 6, lg: 4, xl: 4 }} className="why-choose-card mt-10 instr-card " sx={{ alignItems: !md900 && "center" }}>
                                <div className="mt-10">
                                    <img src={cardimg} />
                                </div>
                                <p className="mt-10 head"><span className="grd">No Investment Required</span></p>
                                <p className="mt-10">No Investment Required: Becoming an IB partner with us requires no investment, making it an ideal opportunity for anyone looking to start their own business in the forex industry.</p>

                            </Grid>
                            <Grid item size={{ xs: 12, sm: 12, md: 6, lg: 4, xl: 4 }} className="why-choose-card mt-10 instr-card " sx={{ alignItems: !md900 && "center" }}>
                                <div className="mt-10">
                                    <img src={cardimg} />
                                </div>
                                <p className="mt-10 head"><span className="grd">Transparent Reporting</span></p>
                                <p className="mt-10">We value transparency and provide our IB partners with real-time reports on their referred clients's trading activity and commission earnings. This transparency ensures that our partners can track their progress and earnings with ease.</p>

                            </Grid>


                        </Grid>


                    </div>
                </section>

                <section className="trade-easy sec-3 cncl">
                    <div className="contain-width">
                        <div className="heading">

                            <h2>
                                Conclusion
                            </h2>
                            <p>
                                Our IB Partner Program is designed to help you grow your business while offering your clients access to the best forex trading experience. With competitive commissions, marketing support, dedicated support, cutting-edge technology, and transparency, partnering with us is a win-win situation for everyone. Sign up today and start growing your business with us!
                            </p>
                        </div>


                    </div>
                </section>
            </div>


            <section class="cta-sec2 out-cta">
                <div className="contain-width">
                    <Grid container spacing={8}>
                        <Grid item size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
                            <label>Your Partner in Trading Success</label>
                            <h2 >Register Now for Seamless Trading with Finowiz</h2>
                            {/* <p>
                            Learn to trade without using real money, refining your
                            strategies and learning from mistakes.
                          </p> */}
                            <Link to="#" className="brd-btn" >
                                Register Now
                            </Link>
                        </Grid>
                    </Grid>
                </div>
            </section>


            <Footer />
        </div>
    );
};

export default IntroductionBroker;
